module.exports = __webpack_public_path__ + "img/fixed-cost.5315c9f9.png";